import ModalWindow from "../../../../../../Components/ModalWindow/ModalWindow.js";
import ApiKeyRequests from "../../../../../../Services/Api/ApiKeyRequests.ts";
import UsersRequests from "../../../../../../Services/Api/UserRequests.ts";
import { AddToastNotification } from "../../../../../../Services/ToastNotification/ToastNotificationManager.js";

const ResetKeyModal = ({apiKey, hide}) => {
    const apiKeyRequests = new ApiKeyRequests();
    
    const reset = () => {
        apiKeyRequests.ResetKey(apiKey.id, () => 
        {
            AddToastNotification("Klucz api zresetowany!", 1)
            hide();
        });
    }

    return (
        <ModalWindow 
            title={"Restart klucza API"}
            buttons={[
                { Text: "Tak", onClick: () => reset() },
                { Text: "Nie", className: "modalSecondaryBtn", onClick: () => hide() }
            ]}
            content={
                <div>
                    Czy na pewno chcesz zrestartować klucz API <span className="text-glred">{apiKey.name}</span>?
                </div>
            }
        />
    )
};

export default ResetKeyModal;